// Factual ActiveRehab Centre Clinic Configuration & Business Data

export const clinicConfig = {
  name: "ActiveRehab Centre",
  fullName: "ActiveRehab Chiropractic & Rehabilitation Centre",
  tagline: "Chiropractic & Rehabilitation Care in Kondapur & Kompally, Hyderabad",
  
  phone: "+91 9000229040",
  phoneRaw: "+919000229040",
  whatsapp: "+91 9000229040",
  whatsappRaw: "919000229040",
  email: "activerehab.in@gmail.com",

  doctor: {
    name: "Dr. Ashok P. Kota",
    qualification: "Master of Chiropractic",
    role: "Lead Chiropractor & Rehabilitation Specialist",
    experienceYears: "17+",
    experienceText: "17+ Years Experience",
    patientsTreated: "5,000+",
    image: "/images/doctorphoto.webp",
    bio: "Dr. Ashok P. Kota is an experienced chiropractic and rehabilitation specialist in Hyderabad. Dedicated to patient-centred care, Dr. Ashok provides individual physical assessments and gentle chiropractic adjustments tailored to help patients recover from back pain, neck pain, posture issues, and joint discomfort across our Kondapur and Kompally clinics.",
    qualifications: [
      "Master of Chiropractic",
      "Rehabilitation Therapy Specialist",
      "Spine & Joint Alignment Expert",
      "Posture & Movement Correction"
    ]
  },

  centresCount: 2,
  totalCentres: "2 Hyderabad Locations",
  cityServiced: "Hyderabad",

  branches: {
    kondapur: {
      id: "kondapur",
      name: "ActiveRehab Kondapur",
      fullName: "ActiveRehab Chiropractic and Physiotherapy Centre Hyderabad",
      shortLabel: "Kondapur",
      address: "Plot No. 1272, 80 Feet Road, above Burfi Ghar, Rajarajeshwara Colony, Kondapur",
      city: "Hyderabad",
      state: "Telangana",
      pincode: "500084",
      fullAddress: "Plot No. 1272, 80 Feet Road, above Burfi Ghar, Rajarajeshwara Colony, Kondapur, Hyderabad, Telangana 500084",
      phone: "+91 9000229040",
      phoneRaw: "+919000229040",
      mapsLink: "https://maps.app.goo.gl/DreQ38PMATcsxC6w9",
      directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=Plot+No.+1272,+80+Feet+Road,+above+Burfi+Ghar,+Rajarajeshwara+Colony,+Kondapur,+Telangana+500084",
      nearbyAreas: "Kondapur, Gachibowli, HITEC City, Madhapur, Jubilee Hills",
      googleRating: 4.8,
      reviewCount: 204,
      embedMapUrl: "https://maps.google.com/maps?q=ActiveRehab+Chiropractic+and+Physiotherapy+Centre+Kondapur+Hyderabad&t=&z=15&ie=UTF8&iwloc=&output=embed"
    },
    kompally: {
      id: "kompally",
      name: "ActiveRehab Kompally",
      fullName: "ActiveRehab Chiropractic and Physiotherapy Centre",
      shortLabel: "Kompally",
      address: "Hale Clinics, Survey No. 43, 2nd Floor, beside Bajaj Electronics, above Manyavar, Suchitra Road, Petbasheerabad, Quthbullapur, Opp. Decathlon, Kompally",
      city: "Hyderabad",
      state: "Telangana",
      pincode: "500055",
      fullAddress: "Hale Clinics, Survey No. 43, Second Floor, beside Bajaj Electronics, above Manyavar, Suchitra Road, Petbasheerabad, Quthbullapur, Opp. Decathlon, Kompally, Hyderabad, Telangana 500055",
      phone: "+91 9000229040",
      phoneRaw: "+919000229040",
      mapsLink: "https://maps.app.goo.gl/TbH3ZDQ6Yd7uKChs7",
      directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=Hale+Clinics,+Survey+No.+43,+Suchitra+Road,+Petbasheerabad,+Quthbullapur,+Opp.+Decathlon,+Kompally,+Hyderabad,+Telangana+500055",
      nearbyAreas: "Kompally, Suchitra, Petbasheerabad, Quthbullapur, Medchal, Alwal",
      googleRating: 4.8,
      reviewCount: 73,
      embedMapUrl: "https://maps.google.com/maps?q=Hale+Clinics+Survey+No+43+Suchitra+Road+Kompally+Hyderabad&t=&z=15&ie=UTF8&iwloc=&output=embed"
    }
  },

  timings: {
    days: "Monday - Saturday",
    hours: "9:00 AM - 9:00 PM",
    sunday: "Closed / By Prior Appointment"
  },

  emailjs: {
    serviceId: "service_xnocv4r",
    templateId: "template_ihtju25",
    publicKey: "iEz80bY3eySot8Qa9"
  },

  tracking: {
    googleAdsId: "AW-16732521690",
    conversionSendTo: "AW-16732521690/xT1WCKjEkdkaENqJ2Ko-",
    ga4Id: "G-NXBV005KF5"
  }
};
